import React from 'react';
import PropTypes from 'prop-types';
import styles from './PageContainer.module.css';

const PageContainer = ({
  children,
  maxWidth = 'xl',
  padding = 'md',
  className = '',
  ...rest
}) => {
  const containerClasses = [
    styles.container,
    styles[`maxWidth-${maxWidth}`],
    styles[`padding-${padding}`],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} {...rest}>
      {children}
    </div>
  );
};

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl', 'full']),
  padding: PropTypes.oneOf(['none', 'sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default PageContainer;
